export const defaultHeaders = {
  "Content-Type": "application/json",
  Accept: "application/json",
};
export const authHeader = (token: string) => ({
  "X-Heaps-Access-Token": token,
});

export const getAuthAndDefaultHeaders = (token: string) => ({
  ...defaultHeaders,
  ...authHeader(token),
});
